<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
        <div class="box">
          <div class="word-container">
            <div :id="`word${index}`" class="word" v-for="(word, index) in showWordList.slice(0, 3)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <div class="word-container">
            <div :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
        
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/0.png">
        <!-- <img id="partner" src="@/assets/game5-6/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="walkAudio" preload="auto">
          <source :src="this.walkAudio">
        </audio>
        <audio id="tianAudio" preload="auto">
          <source :src="this.tianAudio">
        </audio>
         <audio id="baoAudio" preload="auto">
          <source :src="this.baoAudio">
        </audio>
         <audio id="successAudio" preload="auto">
          <source :src="this.successAudio">
        </audio>
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title">{{index}} {{gameName}}</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/>
        </Overlay>
        </div>
      </div>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
  created () {
    this.tianAudioVoice = new Howl({
      src: [this.tianAudio],
      html5: isIOS
    });
    this.walkAudioVoice = new Howl({
      src: [this.walkAudio],
      html5: isIOS
    });
    this.baoAudioVoice = new Howl({
      src: [this.baoAudio],
      html5: isIOS
    });
    this.successAudioVoice = new Howl({
      src: [this.successAudio],
      html5: isIOS
    });
  },
  beforeDestroy () {
    this.tianAudioVoice.pause()
    this.walkAudioVoice.pause()
    this.baoAudioVoice.pause()
    this.successAudioVoice.pause()
  },
  data() {
    return {
      tianAudioVoice: null,
      walkAudioVoice: null,
      baoAudioVoice: null,
      successAudioVoice: null,
      personTarget: {
        left: null,
        top: null,
      },
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      tianAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/sounds/tian.mp3`,
      walkAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/sounds/walk.mp3`,
      baoAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/sounds/bao.mp3`,
      successAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/sounds/out.mp3`,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      boardImgLength: 2, // 箱子
      clapImgLength: 51, // 摸肚子
      workImgLength: 77, // 走路动画
      baoImgLength: 118, // 包西瓜
      digImgLength: 230 // 小人挖宝动画
    }
  },
  watch: {
    isWalk(val) {
      this.$nextTick(() => {
        const person = document.getElementById('person')
        if (val) {
          person.style.zIndex = 60
        } else {
          console.log('person.style.left', person.style.left, this.personTarget.left)
          if (!person.style.left || person.style.left.slice(0,-2) == this.personTarget.left) {
            person.style.zIndex = 40
          }
        }
      })
    }
  },
  mounted() {
    this.initPersonLocation()
  },
  methods: {
    isEmpty,
    initPersonLocation(){
      const personTarget = document.getElementById('person')
      this.personTarget.top = personTarget.offsetTop
      this.personTarget.left = personTarget.offsetLeft
      console.log('personTarget', this.personTarget)
    },
    // 猪八戒抱西瓜
    boardGifHandler (id, index) {
      clearInterval(this.timerBoard)
      this.timerBoard = null
      let i = this.workImgLength
      

      const person = document.getElementById('person')
      this.timerBoard = setInterval(() => {
        this.isWalk = true
        if (i == this.workImgLength+1) {
          // document.getElementById('baoAudio').play()
          this.baoAudioVoice.play()
          const flowerTarget = document.querySelector(`#word${index} .flower`)
          flowerTarget.style.display = 'none'
        }
        if (i>=this.baoImgLength) {
          clearInterval(this.timerBoard)
          this.timerBoard = null
          this.animes(`word${index}`, index)
          this.personDigGifHandler(`${id}`, index)
          // target.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/anime/type${animeType}/${0}.png`
        
        } else {
          i=i+1
          console.log('bao', `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`)

          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`
        }
      }, 50)
    },
    // 摸肚子
    personClapGifHandler (word, index) {
      clearInterval(this.timerClap)
      let i = 0
      // document.getElementById('tianAudio').play()
      this.tianAudioVoice.play()
      const person = document.getElementById('person')
      this.timerClap = setInterval(() => {
        this.isWalk = true
        if (i>=this.clapImgLength) {
          clearInterval(this.timerClap)
          this.personWalkGifHandler(word, index)
          // document.getElementById('walkAudio').play()
          this.walkAudioVoice.play()
          // this.isWalk = false
          // person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${0}.png`
        } else {
          i=i+1
          console.log('clap', `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`)
          person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`
        }
      }, 50)
    },
    // 走路动画
    personWalkGifHandler (word, index) {
      clearInterval(this.timerWalk)
      this.timerWalk = null
      let i = this.clapImgLength
      const person = document.getElementById('person')
      const target = document.getElementById(`${word}`)
      this.animation = anime({
        targets: person,
        left: `${target.offsetLeft-person.offsetWidth/2-person.offsetWidth*0.1}px`,
        top: `${target.offsetTop-target.offsetHeight-person.offsetHeight*0.1}px`,
        // left: `${target.offsetLeft-person.offsetWidth+person.offsetWidth*0.08}px`,
        // top: `${target.offsetTop - target.offsetHeight -person.offsetHeight + person.offsetHeight*0.13}px`,
        // top: `${this.isVertical ? document.body.clientWidth - target.offsetTop - target.offsetHeight - person.offsetHeight*0.244 : document.body.clientHeight - target.offsetTop - target.offsetHeight - person.offsetHeight*0.244}px`,
        
        easing: 'easeInOutQuad',
        duration: (this.workImgLength-this.clapImgLength)*40, // 走路多久到达的时间 走路的动作乘以时间
        complete: () => {
         
          // target.innerHTML = '到达'
          clearInterval(this.timerWalk)
          this.boardGifHandler(`word${index}`, index)
        }
      });
      this.timerWalk = setInterval(() => {
        this.isWalk = true
        // 前面17张走路
        if (i>=this.workImgLength) {
          clearInterval(this.timerWalk)
          this.timerWalk = null
          // this.isWalk = false
        } else {
          i=i+1
          console.log('walk', `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`)

          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`
        }
      }, 40)
    },
    animes(word) {
      const person = document.getElementById('person')
      const target = document.getElementById(word)
      target.style.left = `${target.offsetLeft}px`
      // 推土机动
      this.animation2 = anime({
        targets: person,
        left: `${this.isVertical ? document.body.clientHeight+person.offsetWidth/2 :  document.body.clientWidth+person.offsetWidth/2}px`,
        bottom: `${target.offsetTop + target.offsetHeight}px`,
        // top: `${this.isVertical ? document.body.clientWidth - target.offsetTop - target.offsetHeight : document.body.clientHeight - target.offsetTop - target.offsetHeight}px`,
        easing: 'easeInOutQuad',
        duration: (this.digImgLength-this.baoImgLength)*40, // 走路多久到达的时间 走路的动作乘以时间
        complete: () => {
          person.style.right = null
          person.style.top = `${this.personTarget.top}px`
          person.style.left = `${this.personTarget.left}px`
          person.style.bottom = null
          person.style.display = 'block'
          // target.style.display = 'none'
          this.$nextTick(() => {
            clearInterval(this.timerDig)
            this.timerDig = null
            this.isWalk = false
            person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${0}.png`
            // target.innerHTML = '到达'
            this.getData(true)
          })
        }
      });
    },
    // 挖宝动画
    personDigGifHandler () {
      // document.getElementById('successAudio').play()
      this.successAudioVoice.play()
      clearInterval(this.timerDig)
      this.timerDig = null
      let i = this.baoImgLength
      const person = document.getElementById('person')
      this.timerDig = setInterval(() => {
        this.isWalk = true
        if (i >= this.digImgLength) {
          person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${0}.png`
        } else {
          i=i+1
          console.log('dig', `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`)

          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/walk/${i}.png`
        }
      }, 40)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null
        const person = document.getElementById('person')
        person.style.right = null
        person.style.top = `${this.personTarget.top}px`
        person.style.left = `${this.personTarget.left}px`
        person.style.bottom = null
        

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          word.style.display = 'block'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/anime/type0/${0}.png`

        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          word.style.display = 'block'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/anime/type0/${0}.png`
        }
        this.$nextTick(() => {
          document.getElementById('word0').style.left = '30%'
          document.getElementById('word3').style.left = '30%'
          document.getElementById('word1').style.left = '50%'
          document.getElementById('word4').style.left = '50%'
          document.getElementById('word2').style.left = '70%'
          document.getElementById('word5').style.left = '70%'
        })
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)

      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        return false
      }
      
      this.showWordList[index].clicked = true

      this.playClickAudio()
      
      this.personClapGifHandler(`word${index}`, index)
      // 文字消失
      const wordTarget = document.querySelector(`#word${index} div`)
      wordTarget.style.display = 'none'
      // 变换成第一个花苞
      const flowerTarget = document.querySelector(`#word${index} .flower`)
      flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/anime/type0/${1}.png`

      
     
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game5-6/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
}
// .logo {
//   width: 12px;
//   left: 5px;
//   top: 10PX;
//   position: fixed;
// }
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.box {
  position: absolute;
  right: 10%;
  bottom: 50px;
}
.word-container {
  
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  height: 112.83px;
  &:nth-of-type(1) {
    // margin-left: 120px;
  }
  &:nth-of-type(2) {
    margin-top: 10px;
  }
  .word {
    transform-origin: center;
    width: 106px;
    height: 112.83px;
    font-size: 30px;
    z-index: 60;
    // font-weight: bolder;
    position: fixed;
    .light {
      display: none;
      position: absolute;
      width: 70%;
      left: 18%;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 99;
    }
    .flower {
      position: absolute; 
      width: 100%;
      // width: 319.5px;
      // height: 416.5px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    .icon {
      z-index: 60;
      display: block;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 74px;
      height: 74px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 22%;
    }
  }
  #word0 {
    left: 30%;
  }
  #word1 {
    left: 50%;
  }
  #word2 {
    left: 70%;
  }
  #word3 {
    left: 30%;
  }
  #word4 {
    left: 50%;
  }
  #word5 {
    left: 70%;
  }
}
#person {
  width: 330px;
  position: fixed;
  left: -5%;
  top: -4%;
  z-index: 40;
}
}
</style>